import { Column, Entity, Index, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { ISo } from './interface/ISo';
import { IRefChapterRubric } from './interface/IRefChapterRubric';
import { IInstallation } from './interface/IInstallation';

@Entity('so')
export class So extends BaseEntity implements ISo{
  apiMapping = {
      id: 'extId',
      // installationId: {
      //     type: 'Installation',
      //     fieldName: 'installation'
      // },
      refChapteRubricId: {
        type: 'RefChapterRubric',
        fieldName: 'refChapterRubric'
      }
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column({ nullable: true })
  @Index()
  extId: number;

  // @Column()
  // SOXRefChapterId: number;

  // @Column()
  // SOXRefRubricId: number;

  @ManyToOne('RefChapterRubric')
  refChapterRubric: IRefChapterRubric;

  @ManyToOne('Installation', 'sansObjets')
  installation: IInstallation;
}
